export interface NavItem {
  id: number;
  title: string;
  link: string;
  submenu?: NavItem[];
  megaMenu?: "services" | "products";
}

export const mainNavigation: NavItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    title: "Services",
    link: "/service",
    megaMenu: "services",
    submenu: [
      { id: 21, title: "Website Design", link: "/website-design" },
      {
        id: 22,
        title: "Mobile App Development",
        link: "/mobile-app-development",
      },
      { id: 23, title: "Web Development", link: "/web-development" },
      { id: 24, title: "UI/UX Design", link: "/ui-ux-design" },
      {
        id: 25,
        title: "E-Commerce Development",
        link: "/e-commerce-development",
      },
      { id: 26, title: "Chat Bot", link: "/chat-bot" },
      {
        id: 27,
        title: "Software Testing",
        link: "/software-testing",
      },
      {
        id: 28,
        title: "Website Redesigning",
        link: "/website-redesigning",
      },
      {
        id: 29,
        title: "Website Maintenance",
        link: "/website-maintenance",
      },
      {
        id: 30,
        title: "Digital Marketing",
        link: "/digital-marketing",
      },
      { id: 31, title: "Data Analytics", link: "/data-analytics" },
    ],
  },
  {
    id: 3,
    title: "Portfolio",
    link: "/project",
  },
  {
    id: 4,
    title: "Blog",
    link: "/blog",
  },
  {
    id: 5,
    title: "Products",
    link: "/project",
    megaMenu: "products",
    submenu: [
      {
        id: 51,
        title: "School Management System",
        link: "/school-management-system",
      },
      {
        id: 52,
        title: "Hospital management System",
        link: "/hospital-management-system",
      },
      {
        id: 53,
        title: "Food Delivery Website & App",
        link: "/food-delivery-website-app",
      },
      {
        id: 54,
        title: "Taxi Booking App Like Uber and Ola",
        link: "/taxi-booking-app",
      },
      {
        id: 55,
        title: "Grocery Delivery App",
        link: "/grocery-delivery-app",
      },
      {
        id: 56,
        title: "University|Institution|College ERP",
        link: "/university-institution-college-erp",
      },
      { id: 57, title: "E-Commerce App", link: "/e-commerce-app" },
      {
        id: 58,
        title: "Online Exam Software",
        link: "/online-exam-software",
      },
      { id: 59, title: "HRM", link: "/hrm" },
    ],
  },
  {
    id: 6,
    title: "Contact Us",
    link: "/contact",
  },
];

export const getServicesMenuItems = (): NavItem[] =>
  mainNavigation.find((item) => item.megaMenu === "services")?.submenu ?? [];

export const getProductsMenuItems = (): NavItem[] =>
  mainNavigation.find((item) => item.megaMenu === "products")?.submenu ?? [];
